import { AttemptId, MetadataDataSource, ProductId, QuizId } from "../datasource";
import {
	AttemptScore, OverviewScore, ReviewScore, ScoreDataSource
} from "../datasource/score";
import { MetadataModel, ScoreModel } from "../model";

export class OverviewMetadataModel<P extends ProductId, A extends AttemptId> extends MetadataModel<P, A> {
	constructor(datasource: MetadataDataSource<P, A>) {
		super(datasource);
	}

	getProductId(): Promise<P> {
		return this.datasource.getProductId();
	}

	getAttempt(): Promise<A> {
		throw new Error('Invalid Query: Overview does not have an attempt id');
	}

	getUrl(): Promise<string> {
		return this.datasource.getUrl();
	}

	getScreenshot(): Promise<string> {
		throw new Error("Method not implemented.");
	}
}

export class OverviewScoreModel<A extends AttemptId, Z extends QuizId> extends ScoreModel<A, Z> {
	constructor(datasource: ScoreDataSource<A, Z>) {
		super(datasource);
	}

	getOverviewScores(): Promise<OverviewScore<A, Z>[]> {
		return this.datasource.getOverviewScores()
			.then((scores: AttemptScore<A, Z>) => {
				const result: OverviewScore<A, Z>[] = Object.keys(scores)
					.map((index: string) => ({
						quiz: this.datasource.quizIdSerializer.parse(index),
						data: scores[index]
					}));
				return result;
			})
			.catch((err: any) => {
				// TODO: Instrumenting New Relic might help here. Need to
				//  use noticeError().
				console.error(err);
				return [];
			});
	}

	getReviewScores(): Promise<ReviewScore[]> {
		throw new Error("Method not implemented.");
	}

	getTotalScores(): Promise<ReviewScore> {
		throw new Error("Method not implemented.");
	}
}